import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _noop from 'lodash/noop';
import _trimStart from 'lodash/trimStart';

// Components
import Input from '../../../../../../../molecules/Input';
import TextualAction from '../../../../../atoms/textualAction';

// Constants
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants'; // eslint-disable-line
import { FILTER_GROUP_NAME_CHANGE, FILTER_GROUP_SAVE, FILTER_GROUP_EDIT_CANCEL } from './filterHeaderEdit.actionTypes';

// Styles
import s from './filterHeaderEdit.module.scss';
var FileHeaderEdit = /*#__PURE__*/function (_PureComponent) {
  _inherits(FileHeaderEdit, _PureComponent);
  var _super = _createSuper(FileHeaderEdit);
  function FileHeaderEdit() {
    var _this;
    _classCallCheck(this, FileHeaderEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      var onAction = _this.props.onAction;
      e.stopPropagation();
      var filterGroupName = _get(e, 'target.value');
      onAction({
        type: FILTER_GROUP_NAME_CHANGE,
        payload: {
          filterGroupName: _trimStart(filterGroupName)
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleSave", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: FILTER_GROUP_SAVE
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleCancel", function () {
      var onAction = _this.props.onAction;
      onAction({
        type: FILTER_GROUP_EDIT_CANCEL
      });
    });
    return _this;
  }
  _createClass(FileHeaderEdit, [{
    key: "renderActions",
    value: function renderActions() {
      var _this$props = this.props,
        saveActionCustomClass = _this$props.saveActionCustomClass,
        cancelActionCustomClass = _this$props.cancelActionCustomClass;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextualAction, {
        label: __('Save'),
        onClick: this.handleSave,
        className: "".concat(s.saveAction, " ").concat(saveActionCustomClass)
      }), /*#__PURE__*/React.createElement(TextualAction, {
        className: cancelActionCustomClass,
        label: __('Cancel'),
        onClick: this.handleCancel
      }));
    }
  }, {
    key: "renderInput",
    value: function renderInput() {
      var _this$props2 = this.props,
        filterGroupName = _this$props2.filterGroupName,
        errors = _this$props2.errors,
        customFilterGroupClass = _this$props2.customFilterGroupClass;
      var filterGroupNameError = _get(errors, 'filterGroupName');
      return /*#__PURE__*/React.createElement(Input, {
        onChange: this.handleInputChange,
        value: filterGroupName,
        className: "".concat(s.input, " ").concat(customFilterGroupClass),
        error: filterGroupNameError
      });
    }
  }, {
    key: "render",
    value: function render() {
      var filterHeaderEditContainer = this.props.filterHeaderEditContainer;
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(s.container, " ").concat(filterHeaderEditContainer)
      }, this.renderInput(), this.renderActions());
    }
  }]);
  return FileHeaderEdit;
}(PureComponent);
FileHeaderEdit.propTypes = {
  filterGroupName: PropTypes.string,
  onAction: PropTypes.func,
  errors: PropTypes.object,
  customFilterGroupClass: PropTypes.string,
  filterHeaderEditContainer: PropTypes.string,
  saveActionCustomClass: PropTypes.string,
  cancelActionCustomClass: PropTypes.string
};
FileHeaderEdit.defaultProps = {
  filterGroupName: '',
  onAction: _noop,
  errors: EMPTY_OBJECT,
  customFilterGroupClass: EMPTY_STRING,
  filterHeaderEditContainer: EMPTY_STRING,
  saveActionCustomClass: EMPTY_STRING,
  cancelActionCustomClass: EMPTY_STRING
};
export default FileHeaderEdit;